import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [showDialog, setShowDialog] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    setEmail("");
    setShowDialog(true);
  };

  return (
    <>
      <footer className="bg-gradient-to-r from-purple-800 to-indigo-900 text-white py-16 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-10">
          {/* About */}
          <div className="md:col-span-2">
            <h2 className="text-3xl font-extrabold mb-4 text-pink-400">
              Vicademics
            </h2>
            <p className="text-indigo-200 mb-4">
              Your trusted platform for online education and career upskilling.
              Empower your learning journey with Vicademics — explore, buy, and
              master courses from expert instructors worldwide.
            </p>
            <div className="flex space-x-4 mt-6 text-indigo-300 text-xl">
              <a
                href="https://www.facebook.com/profile.php?id=61582353581335"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink-400 transition"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.linkedin.com/company/109681051/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink-400 transition"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://www.youtube.com/@Vicademics"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink-400 transition"
              >
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-pink-400">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/home" className="hover:text-pink-400 transition">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/browse-courses"
                  className="hover:text-pink-400 transition"
                >
                  Courses
                </Link>
              </li>
              <li>
                <Link
                  to="/instructors"
                  className="hover:text-pink-400 transition"
                >
                  Instructors
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-pink-400 transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-pink-400 transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-pink-400">
              Support
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="hover:text-pink-400 transition">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/help" className="hover:text-pink-400 transition">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-pink-400 transition">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-pink-400 transition">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refunds" className="hover:text-pink-400 transition">
                  Refund & Cancellation
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Contact + Newsletter Row */}
        <div className="mt-12 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Contact Us */}
          <div>
            <h3 className="text-xl font-semibold mb-4 text-pink-400">
              Contact Us
            </h3>
            <p className="text-indigo-200 mb-2">
              Email: support@vicademics.com
            </p>
          </div>

          {/* Stay Updated */}
          <div className="text-center md:text-right">
            <h3 className="text-xl font-semibold mb-4 text-pink-400">
              Stay Updated
            </h3>
            <form
              onSubmit={handleSubscribe}
              className="flex flex-col md:flex-row md:justify-end items-center gap-4"
            >
              <input
                type="email"
                placeholder="Your email address"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-4 py-2 rounded-md border border-indigo-500 bg-indigo-800 text-indigo-100 placeholder-indigo-400 focus:outline-none focus:ring-2 focus:ring-pink-500"
              />
              <button
                type="submit"
                className="bg-pink-500 hover:bg-pink-600 text-white font-semibold px-6 py-2 rounded-md transition"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <p className="text-center text-indigo-300 text-sm mt-10 border-t border-indigo-700 pt-6">
          &copy; {new Date().getFullYear()} Vicademics Software. All rights
          reserved.
        </p>
      </footer>

      {/* Success Dialog */}
      {showDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-2xl p-6 text-center max-w-sm w-full">
            <h2 className="text-2xl font-bold text-pink-600 mb-4">
              🎉 Subscribed!
            </h2>
            <p className="text-gray-700 mb-6">
              Thank you for subscribing to Vicademics updates.
            </p>
            <button
              onClick={() => setShowDialog(false)}
              className="bg-pink-500 hover:bg-pink-600 text-white font-semibold px-6 py-2 rounded-md transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
